import { render, staticRenderFns } from "./updateForm.vue?vue&type=template&id=2311a0e0&scoped=true"
import script from "./updateForm.vue?vue&type=script&lang=js"
export * from "./updateForm.vue?vue&type=script&lang=js"
import style0 from "./updateForm.vue?vue&type=style&index=0&id=2311a0e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2311a0e0",
  null
  
)

export default component.exports